import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useB2BTranslation } from "../B2BShared/hooks/useB2BTranslation";
import "./B2BCorporatePaymentsPage.css";

const B2BCorporatePaymentsPage: React.FC = () => {
  const { t } = useB2BTranslation();

  return (
    <div className="corporate-payments-page">
      <div className="payments-header">
        <Link
          to="/gcb"
          className="back-button"
        >
          <ArrowLeft size={20} />
          {t("corporatePayments.backToB2B")}
        </Link>
        <h1>{t("corporatePayments.title")}</h1>
        <p>{t("corporatePayments.subtitle")}</p>
      </div>

      <div className="payments-container">
        <div className="payments-hero">
          <div className="hero-content">
            <h2>{t("corporatePayments.heroTitle")}</h2>
            <p>{t("corporatePayments.heroDescription")}</p>
            <p>{t("corporatePayments.freeManager")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default B2BCorporatePaymentsPage;

